import React from "react";
import { Flex } from "@fluentui/react-northstar";
import { InProgressHeader, InProgressMonthName, OpenCard } from "./index.style";
import { HourWorked, TotalHourText, TotalText, WeekName } from "./index.style";
import { _str_capitalize } from "../../../../utils/functions";

/**
 * @typedef {Object} PropTypes
 * @property {{number : string, hours_count: number}[]} weeklyDetail
 * @property {number} total
 * @property {string} month_name
 *
 * MonthDetail to show worked hours by week
 * @param {PropTypes} PropTypes
 * @returns
 */
const MonthDetail = ({ weeklyDetail, total, month_name }) => {
    return (
        <Flex vAlign="center" hAlign="center" styles={{ paddingBlock: "16px" }}>
            <OpenCard column>
                <InProgressHeader vAlign="center" hAlign="center" fill>
                    <InProgressMonthName
                        content={_str_capitalize(month_name)}
                    />
                </InProgressHeader>

                <Flex
                    fill
                    space="between"
                    column
                    styles={{
                        padding: "16px 24px",
                    }}
                >
                    <Flex gap="gap.smaller" column>
                        {weeklyDetail?.map((el) => {
                            return (
                                <Flex
                                    space="between"
                                    vAlign="center"
                                    hAlign="center"
                                >
                                    <WeekName content={`S.${el?.number}`} />
                                    <HourWorked
                                        content={`${el?.hours_count} h`}
                                    />
                                </Flex>
                            );
                        })}
                    </Flex>
                    <Flex style={{ marginTop: "4px" }} space="between">
                        <TotalText content="Total" />
                        <TotalHourText content={`${total} h`} />
                    </Flex>
                </Flex>
            </OpenCard>
        </Flex>
    );
};

export default MonthDetail;
